import React, { ComponentType } from "react";
import { useLingui } from "@lingui/react";
import { I18n } from "@lingui/core";

export type withI18nProps = {
  i18n: I18n;
};

export function withI18n(
  o?: object,
): <P extends withI18nProps>(
  Component: ComponentType<P>,
) => React.ComponentType<Omit<P, "i18n">> {
  // @ts-ignore
  return <P extends withI18nProps>(
    WrappedComponent: ComponentType<P>,
  ): ComponentType<P> => {
    return (props) => {
      if (process.env.NODE_ENV !== "production") {
        if (typeof o === "function" || React.isValidElement(o)) {
          throw new Error(
            "withI18n([options]) takes options as a first argument, " +
              "but received React component itself. Without options, the Component " +
              "should be wrapped as withI18n()(Component), not withI18n(Component).",
          );
        }
      }

      const { i18n } = useLingui();
      return <WrappedComponent {...props} i18n={i18n} />;
    };
  };
}
